import { RouteRecordRaw } from 'vue-router';

export const taxReceiptRouters: RouteRecordRaw[] = [
  {
    path: '/taxMatch',
    name: 'TaxMatch',
    // component: () => import('@/pages/h5/Report/TaxReceipt/TaxMatch/index.vue'),
    component: () => import('@/pages/h5/Report/TaxReceipt/TaxMatchV2/index.vue'),
    meta: { title: '水母报告', checkAuth: true },
  },
  {
    path: '/taxReceipt',
    name: 'TaxReceipt',
    component: () => import('@/pages/h5/Report/TaxReceipt/index.vue'),
    redirect: '/taxEnterprise',
    children: [
      {
        path: '/taxEnterprise',
        name: 'TaxEnterprise',
        component: () => import('@/pages/h5/Report/TaxReceipt/TaxEnterprise/index.vue'),
      },
    ],
    meta: { title: '水母报告', checkAuth: true },
  },
  {
    path: '/taxAuthorize',
    name: 'TaxAuthorize',
    component: () => import('@/pages/h5/Report/TaxReceipt/TaxAuthorize/index.vue'),
    meta: { title: '电子税局授权' },
  },
  {
    path: '/authorizeResult',
    name: 'AuthorizeResult',
    component: () => import('@/pages/h5/Report/TaxReceipt/TaxAuthorize/AuthorizeResult.vue'),
    meta: { title: '电子税局授权' },
  },
  {
    path: '/taxStateCheck',
    name: 'TaxStateCheck',
    component: () => import('@/pages/h5/Report/TaxReceipt/TaxStateCheck/index.vue'),
    meta: { title: '税票报告' },
  },
];
